import { SliceCaseReducers } from '@reduxjs/toolkit'
import { createOperationSlice, GenericOperationState } from '@repo/core'
import { AddTrustDeviceParams, OtpRequiredResponse } from '@repo/user-types'

const initialState: GenericOperationState<OtpRequiredResponse | null> = {
  payload: null,
  meta: { fetchState: 'initial' },
  error: false,
}

export const { actions: addTrustDeviceActions, reducer: addTrustDeviceReducer } =
  createOperationSlice<
    OtpRequiredResponse | null,
    SliceCaseReducers<GenericOperationState<OtpRequiredResponse | null>>,
    AddTrustDeviceParams
  >({
    name: '@users/devices/addTrustDevice',
    initialState,
    reducers: {},
  })
